import React from 'react';

import PropTypes from 'prop-types';

import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import ButtonLoaderAtom from 'atoms/ButtonLoader';

import { FORM_LAYOUT } from 'constants/layout';
import styles from './styles.module.scss';

/**
 * JobTaskMappingListPage -> JobTaskMappingFilterSection -> ConfirmationModal
 *
 * Props:
 *    - update
 */
class OverrideMealModal extends React.PureComponent {
  constructor(props) {
    super(props);
    console.log('');
  }

  render() {
    const { isOpen,
      toggle, payMeal, confirmMealStatusLoader, rejectMealStatusLoader , closeModal} = this.props;
    return (
      <Modal
        isOpen={isOpen}
        toggle={closeModal}
        backdrop="static"
      >
        <ModalHeader toggle={closeModal}>
          Confirm Meal Status
        </ModalHeader>
        <ModalBody>
          <h5>Do you want meal to be added towards RT, OT and DOT?</h5>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" onClick={() => payMeal()} color="secondary" size={FORM_LAYOUT.size} >
            Yes <ButtonLoaderAtom active={confirmMealStatusLoader} />
          </Button>
          <Button color="default" className={styles['cancel-btn']} onClick={() => toggle()} size={FORM_LAYOUT.size} >
            No <ButtonLoaderAtom active={rejectMealStatusLoader} />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
};


OverrideMealModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default OverrideMealModal;